import styled from 'styled-components';
import { Headline1, Body5 } from './../../app/common/typography';

export const TopSection = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 99;
  background-color: ${({ theme }) => theme.colors.white};
`;

export const RegisterFormWrapper = styled.div`
  background: ${({ theme }) => theme.colors.seasalt};
  padding: ${({ theme }) => theme.spacing.none}
    ${({ theme }) => theme.spacing.m};
  margin-top: 85px;
`;

export const HeaderSection = styled.div`
  padding-bottom: ${({ theme }) => theme.spacing.m};
`;

export const Title = styled(Headline1)`
  color: ${({ theme }) => theme.colors.eerieBlack};
  margin: ${({ theme }) => theme.spacing.none} !important;
  padding-bottom: ${({ theme }) => theme.spacing.s};
  padding-top: 28px;
  text-align: left !important;
`;

export const Divider = styled.div`
  background-color: ${({ theme }) => theme.colors.eerieBlack};
  height: 1px;
  margin-top: ${({ theme }) => theme.spacing.sm};
`;

export const UserRole = styled(Body5)`
  color: ${({ theme }) => theme.colors.eerieBlack};
  margin-top: ${({ theme }) => theme.spacing.s};
`;

export const RoleType = styled(Body5)`
  color: ${({ theme }) => theme.colors.eerieBlack};
  margin-top: ${({ theme }) => theme.spacing.s};
`;

export const FooterWarningConsentWrapper = styled.div`
  display: flex;
  column-gap: ${({ theme }) => theme.spacing.s};
  justify-content: center;
  margin: ${({ theme }) => theme.spacing.xl} 0;
  align-items: flex-start;
`;

export const FooterWarningConsentOptionsContainer = styled.div``;

export const ButtonBlockWrapper = styled.div`
  padding-bottom: ${({ theme }) => theme.spacing.xl};
`;

export const FieldContent = styled.div`
  display: flex;
  margin-bottom: ${({ theme }) => theme.spacing.sm};
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.xs};
`;

export const ErrorLine = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.s};
`;

export const ErrorContainer = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing.s};
  flex-direction: column;
  margin-top: 12px;
`;
